var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.discounts")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", { staticClass: "choose-type" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.selecttype") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row wrapper" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 row no-margin no-padding" },
                            [
                              _c(
                                "vs-radio",
                                {
                                  staticStyle: { float: "left", padding: "0" },
                                  attrs: {
                                    color: "#A3CA76",
                                    vsValue: "general"
                                  },
                                  model: {
                                    value: _vm.form.discount_type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "discount_type", $$v)
                                    },
                                    expression: "form.discount_type"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.discountgeneral"))
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "margin-left": "25px" }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.discountgeneraldetail")
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 row no-margin no-padding" },
                            [
                              _c(
                                "vs-radio",
                                {
                                  staticStyle: { float: "left", padding: "0" },
                                  attrs: {
                                    color: "#A3CA76",
                                    vsValue: "conditional"
                                  },
                                  model: {
                                    value: _vm.form.discount_type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "discount_type", $$v)
                                    },
                                    expression: "form.discount_type"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.discountcondition")
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "margin-left": "25px" }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.discountconditiondetail")
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.general") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row mb-0" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.discount_name")) + " *"
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.discount_name,
                                    expression: "form.discount_name"
                                  }
                                ],
                                ref: "discount_name",
                                staticClass: "form-control discount-name",
                                class: [_vm.class_.discount_name],
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.discount_name },
                                on: {
                                  keyup: _vm.onKeyUpDiscountName,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "discount_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.form.discount_type === "general"
                          ? _c("div", { staticClass: "col" }, [
                              _c(
                                "div",
                                { staticClass: "form-group row mb-0" },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.discount_amount")
                                        ) + " *"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "input-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.amount,
                                            expression: "form.amount"
                                          }
                                        ],
                                        ref: "amount",
                                        staticClass:
                                          "form-control text-right text-select-all",
                                        class: [_vm.class_.amount],
                                        staticStyle: { "border-right": "0" },
                                        attrs: { type: "text" },
                                        domProps: { value: _vm.form.amount },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.form.amount = _vm.setToValidNumber(
                                              _vm.form.amount
                                            )
                                          },
                                          blur: function($event) {
                                            _vm.form.amount = _vm.setToCustomDigitsNumber(
                                              _vm.form.amount
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "amount",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn dropdown-toggle",
                                              staticStyle: {
                                                border: "1px solid #ced4da"
                                              },
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "dropdown",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false"
                                              }
                                            },
                                            [
                                              _vm.form.type == "percentage"
                                                ? [
                                                    _vm._v(
                                                      "\n                          %\n                        "
                                                    )
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.form.type == "number"
                                                ? [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(_vm.currency) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.type =
                                                        "percentage"
                                                    }
                                                  }
                                                },
                                                [_vm._v("%")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.type = "number"
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(_vm.currency))]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.form.discount_type === "conditional"
                        ? _c("div", { staticClass: "form-row mt-2" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.discount_amount")) +
                                    " *"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group row mb-0 no-margin"
                                },
                                [
                                  _c("DiscountCondition", {
                                    attrs: { page: "new" },
                                    model: {
                                      value: _vm.conditions,
                                      callback: function($$v) {
                                        _vm.conditions = $$v
                                      },
                                      expression: "conditions"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.items.length > 0 && _vm.form.discount_name
                  ? _c(
                      "section",
                      {
                        staticClass: "assign-items mt-3",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: {
                                title:
                                  _vm.$t("message.assignitems") +
                                  " (" +
                                  _vm.assignitems.length +
                                  ")"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 row align-items-center no-padding no-margin subheader-assign"
                              },
                              [
                                _c("div", { staticClass: "col no-padding" }, [
                                  _vm._v(_vm._s(_vm.$t("message.productlist")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.items, function(item, index) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 row align-items-center no-padding no-margin item",
                                  class: { active: item.active },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleAssign(item)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "col" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.product_name) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col text-right" },
                                    [
                                      _vm._l(item.discounts, function(
                                        _item,
                                        index
                                      ) {
                                        return _c(
                                          "span",
                                          { staticClass: "comma" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_item.discount_name) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      item.active
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.form.discount_name) +
                                                "\n              "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fas fa-check-circle"
                                      }),
                                      _vm._v(" "),
                                      _c("i", { staticClass: "far fa-circle" })
                                    ],
                                    2
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("section", { staticClass: "mt-4" }, [
                  _c("div", { staticClass: "col-md-12 no-padding" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.applyitemtopos", {
                            item: _vm.$t("sidebar.discounts")
                          })
                        ) +
                        "\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://www.treesoft.io/th/manual/product#discount",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.learnmore")) +
                            "\n            "
                        ),
                        _c("i", { staticClass: "fas fa-external-link-alt" })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "action-bar" }, [
                  !_vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-web",
                            on: {
                              click: function($event) {
                                return _vm.save()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _vm._m(0)
                      ])
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6914d77e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6914d77e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/items/discount/New.vue
// module id = null
// module chunks = 